export function timeFormatters(iso: string):string {
  let date = new Date(iso);

  let now = new Date();
  let diffInTime = now.getTime() - date.getTime();
  let diffInDays = diffInTime / (1000 * 3600 * 24);

  let daysAgo = Math.round(diffInDays);
  return daysAgo <= 0 ? 'сегодня' : daysAgo + ' дней назад';
}

export function formattedWatchTime(time: number): string {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor(time % 3600 / 60);

  return hours < 1 ? (minutes < 1 ? '< 1 мин.' : `${minutes} мин.`) : `${hours} час. ${minutes !== 0 ? minutes + ' мин.' : ''}`;
}

const units: {
  duration: number;
  type: Intl.RelativeTimeFormatUnit;
}[] = [
  {
    duration: 1000 * 24 * 60 * 60 * 365,
    type: 'year',
  },
  {
    duration: (1000 * 24 * 60 * 60 * 365) / 12,
    type: 'month',
  },
  {
    duration: 1000 * 24 * 60 * 60,
    type: 'day',
  },
  {
    duration: 1000 * 60 * 60,
    type: 'hour',
  },
  {
    duration: 1000 * 60,
    type: 'minute',
  },
  {
    duration: 1000,
    type: 'second',
  },
];

const relativeTimeFormatter = new Intl.RelativeTimeFormat('ru-RU', {
  numeric: 'auto',
  style: 'long',
});

export const timeAgo = (date1: Date, date2: Date): string => {
  const elapsed = date1.getTime() - date2.getTime();

    for (const unit of units) {
      if (Math.abs(elapsed) > unit.duration || unit.type === 'second') {
        return relativeTimeFormatter.format(Math.round(elapsed / unit.duration), unit.type);
      }
    }

    throw Error('Could not calculate date ago');
  };

  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  export const datetimeInLocaleLanguageAndTimezone = (date: Date): string =>
    date.toLocaleString('ru-RU', {
      timeZone: currentTimeZone,
    });